import { useMemo } from "react";

import { useAudioStateContext } from "hooks/useAudioStateContext";
import { getFolderOffsetMs } from "utils/globalTime";

/**
 * Смещение открытой папки от начала видео, мс. `null` — посчитать не из чего.
 *
 * Хук, а не проп: значение нужно обеим колонкам дорожек и модалкам, а протаскивать его сквозь
 * два `React.memo`-компонента дороже, чем подписаться на тот же контекст, который они и так
 * читают.
 */
export const useFolderOffsetMs = (): number | null => {
    const state = useAudioStateContext();
    const { subtitlesDataAll, originalLang, lang, folder } = state || {};
    return useMemo(
        () => getFolderOffsetMs({ subtitlesDataAll, originalLang, lang, folder }),
        [subtitlesDataAll, originalLang, lang, folder],
    );
};
